import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import StatsGroupCreateEditForm from './Components/StatsGroupCreateEditForm';
import StatsGroupApi from './StatsGroupApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: StatsGroupCreateEditForm,
                getCreate: StatsGroupApi.create,
                defaults: {matrix:[]},
                successMessage: "StatsGroup Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}